import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import { ToastContainer } from "react-toastify";
import HeadTag from "./HeadTag/HeadTag";
import BgShadow from "./BgShadow";
import NotFound from "./pages/NotFound";
import { Roboto } from "next/font/google";

const roboto = Roboto({
  weight: ["300", "400", "500", "700"],
  subsets: ["latin"],
});

export default function Layout({
  children,
  data,
  dataHeader,
  dataFooter,
  RoutingController,
  RoutingTypeId,
  notFound,
}) {
  if (notFound) {
    return (
      <NotFound dataHeader={dataHeader} dataFooter={dataFooter}>
        {children}
      </NotFound>
    );
  }

  return (
    <div className={roboto.className}>
      <HeadTag title={data.title} description={data.description} data={data} />
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <BgShadow />
      {RoutingTypeId != "SinglePayment" && (
        <Header dataHeader={dataHeader} RoutingController={RoutingController} />
      )}
      <main>{children}</main>
      {RoutingTypeId != "SinglePayment" && (
        <Footer
          dataFooter={dataFooter}
          RoutingController={RoutingController}
          dataHeader={dataHeader}
          RoutingTypeId={RoutingTypeId}
          data={data}
        />
      )}
    </div>
  );
}
